<template>
  <div class="content-scoll">
    <div class="teacher-area">
      <div class="teacher">
        <h5 v-if="group_id">{{'disciplines' | setText('Предметы')}}</h5>
        <ul class="list">
            <li @click="current=journal" :class="`${current && journal.id==current.id ? 'active' : ''}`" v-for="journal in journals" :key="journal.id">
                <span>{{journal.title}} </span>
            </li>
        </ul>
      </div>
        <div class="area">
          <lessonplans v-if="current" :group_id="group_id"  :discipline_id="current.id"/>
        </div>
    </div>
    </div>
</template>
<script>
import Lessonplans from '@/components/Pupils/Decisions/Lessonplans';
import {getJournal} from '@/_api/apiPupil';
export default {
  props: {
    group_id: {
      default:null
    }
  },
  components: {
    Lessonplans
  },
  created(){
      this.getJournal(this.group_id);
  },
  watch: {
    group_id(val){
      this.current   = null;
      this.getJournal(val);
    },
  },
  methods: {
  getJournal:getJournal
  },
  data() {
    return {
       journals:[],
       current : null,
    };
  },
};
</script>

